/* tslint:disable */
/* eslint-disable */
/**
 * grpc/v1/analytics_service.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from '../configuration'
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios'
import globalAxios from 'axios'
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from '../common'
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from '../base'
// @ts-ignore
import type { RequestArgs } from '../base'
// @ts-ignore
import { RpcStatus } from '../models'
// @ts-ignore
import { V1GetAgentDealsReportResponse } from '../models'
// @ts-ignore
import { V1GetAgentPresentationReportResponse } from '../models'
// @ts-ignore
import { V1GetAgentRewardReportResponse } from '../models'
// @ts-ignore
import { V1GetClientSourceReportResponse } from '../models'
// @ts-ignore
import { V1GetClientsKpiResponse } from '../models'
// @ts-ignore
import { V1GetCompanyDealsReportResponse } from '../models'
// @ts-ignore
import { V1GetDashboardMetricsResponse } from '../models'
// @ts-ignore
import { V1GetDealsKpiResponse } from '../models'
// @ts-ignore
import { V1GetFunnelResponse } from '../models'
// @ts-ignore
import { V1GetLandingConversionReportResponse } from '../models'
// @ts-ignore
import { V1GetLeadSourcesReportResponse } from '../models'
// @ts-ignore
import { V1GetManagerAnalyticsResponse } from '../models'
// @ts-ignore
import { V1GetManagerLeaderboardResponse } from '../models'
// @ts-ignore
import { V1GetRevenueReportResponse } from '../models'
// @ts-ignore
import { V1GetSalesReportResponse } from '../models'
// @ts-ignore
import { V1PresentationStatsResponse } from '../models'
// @ts-ignore
import { V1RunReconcileRequest } from '../models'
// @ts-ignore
import { V1RunReconcileResponse } from '../models'
/**
 * AnalyticsServiceApi - axios parameter creator
 * @export
 */
export const AnalyticsServiceApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary GetAgentDealsReport — сделки в разрезе агента: клиенты/сделки/победы/депозиты, конверсия клиент→депозит, выручка, прогноз вознаграждения.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentDealsReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/agent-deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentPresentationReport — сводная по агентам (Reports-таб): строки на агента + общие totals/daily по видимым. ADMIN/HOS/CEO — все; MANAGER — только курируемые.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/agent-presentations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentPresentationStats — та же статистика по конкретному агенту (карточка агента в CRM). ADMIN/HOS/CEO — любой агент; MANAGER — только курируемый.
     * @param {string} agentId
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationStats: async (
      agentId: string,
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'agentId' is not null or undefined
      assertParamExists('analyticsServiceGetAgentPresentationStats', 'agentId', agentId)
      const localVarPath = `/api/v1/analytics/reports/agent-presentations/{agentId}`.replace(
        `{${'agentId'}}`,
        encodeURIComponent(String(agentId)),
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetAgentRewardReport — распределение агентских сделок по статусу вознаграждения (expected/approved/paid/disputed/cancelled) с суммой прогноза.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentRewardReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/agent-reward`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetClientSourceReport — эффективность источников клиентов (client_source_type: Agent/Direct/Marketing/...): клиенты, сделки, победы, конверсия.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientSourceReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/client-source`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetClientsKpi — KPI экрана «Клиенты» (DEV-281).
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientsKpi: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/clients-kpi`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetCompanyDealsReport — сделки в разрезе компании-партнёра (+ число агентов).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetCompanyDealsReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/company-deals`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetDashboardMetrics — все метрики дашборда одним вызовом (DEV-280): KPI (клиенты/сделки/объекты/конверсия) + спарклайны + донат источников лидов + помесячный график сделок. Заменяет 3 fan-out вызова + N+1 на донате.
     * @param {string} [period] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDashboardMetrics: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/dashboard`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetDealsKpi — KPI экрана «Сделки» + разрез по этапам для канбана (DEV-282).
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDealsKpi: async (
      period?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/deals-kpi`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (period !== undefined) {
        localVarQueryParameter['period'] = period
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetFunnel — воронка: число сделок по этапам + конверсии (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetFunnel: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/funnel`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingConversionReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/landings`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLeadSourcesReport — распределение по источникам лидов (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLeadSourcesReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/lead-sources`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetManagerAnalytics — аналитика работы менеджеров (DEV-380, наследие DEV-197): участие по этапам воронки, исходы Won/Lost при участии, задачи выполнено/просрочено. ТОЛЬКО HOS/ADMIN. Имена менеджеров FE резолвит по manager_id (useManagers).
     * @param {string} [from] начало периода (пусто &#x3D; без границы)
     * @param {string} [to] конец периода (пусто &#x3D; без границы)
     * @param {Array<string>} [managerIds] фильтр по менеджерам (пусто &#x3D; все)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerAnalytics: async (
      from?: string,
      to?: string,
      managerIds?: Array<string>,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/manager-analytics`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (from !== undefined) {
        localVarQueryParameter['from'] =
          (from as any) instanceof Date ? (from as any).toISOString() : from
      }

      if (to !== undefined) {
        localVarQueryParameter['to'] = (to as any) instanceof Date ? (to as any).toISOString() : to
      }

      if (managerIds) {
        localVarQueryParameter['managerIds'] = managerIds
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetManagerLeaderboard — лидерборд менеджеров (DEV-285/DEV-197). ТОЛЬКО HOS/ADMIN.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerLeaderboard: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/manager-leaderboard`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (paginationPage !== undefined) {
        localVarQueryParameter['pagination.page'] = paginationPage
      }

      if (paginationPerPage !== undefined) {
        localVarQueryParameter['pagination.perPage'] = paginationPerPage
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetMyPresentationStats — статистика презентаций текущего агента (self-scope, роль AGENT): создано/отправлено/просмотры, конверсия, суточная динамика, топ.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetMyPresentationStats: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/presentations/my`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetRevenueReport — отчёт по выручке с группировкой (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [groupBy] Группировка: временные бакеты или категории.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetRevenueReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      groupBy?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/revenue`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      if (groupBy !== undefined) {
        localVarQueryParameter['groupBy'] = groupBy
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary GetLandingConversionReport — «лиды / просмотры» по каждому лендингу за период. Маркетинговый отчёт по общему активу: ADMIN/HOS/CEO, скоупа по менеджеру нет. GetSalesReport — отчёт отдела продаж (DEV-1067, ADR-0034): статусная структура заявок, помесячная динамика, эффективность источников, качество агентских лидов. Только HOS/ADMIN/CEO.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesReport: async (
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      const localVarPath = `/api/v1/analytics/reports/sales`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      if (periodPeriod !== undefined) {
        localVarQueryParameter['period.period'] = periodPeriod
      }

      if (periodFrom !== undefined) {
        localVarQueryParameter['period.from'] =
          (periodFrom as any) instanceof Date ? (periodFrom as any).toISOString() : periodFrom
      }

      if (periodTo !== undefined) {
        localVarQueryParameter['period.to'] =
          (periodTo as any) instanceof Date ? (periodTo as any).toISOString() : periodTo
      }

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
    /**
     *
     * @summary RunReconcile — разовая сверка read-model с источниками (ТОЛЬКО admin/HOS). Тянет сделки/клиентов/объекты из сервисов под токеном вызвавшего и идемпотентно наполняет fact-таблицы. Асинхронно: отвечает сразу.
     * @param {V1RunReconcileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceRunReconcile: async (
      body: V1RunReconcileRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'body' is not null or undefined
      assertParamExists('analyticsServiceRunReconcile', 'body', body)
      const localVarPath = `/api/v1/analytics/reconcile`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      localVarHeaderParameter['Content-Type'] = 'application/json'

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      }
      localVarRequestOptions.data = serializeDataIfNeeded(
        body,
        localVarRequestOptions,
        configuration,
      )

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      }
    },
  }
}

/**
 * AnalyticsServiceApi - functional programming interface
 * @export
 */
export const AnalyticsServiceApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AnalyticsServiceApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary GetAgentDealsReport — сделки в разрезе агента: клиенты/сделки/победы/депозиты, конверсия клиент→депозит, выручка, прогноз вознаграждения.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentDealsReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetAgentDealsReport(
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentDealsReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentPresentationReport — сводная по агентам (Reports-таб): строки на агента + общие totals/daily по видимым. ADMIN/HOS/CEO — все; MANAGER — только курируемые.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentPresentationReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetAgentPresentationReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetAgentPresentationReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentPresentationReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentPresentationStats — та же статистика по конкретному агенту (карточка агента в CRM). ADMIN/HOS/CEO — любой агент; MANAGER — только курируемый.
     * @param {string} agentId
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentPresentationStats(
      agentId: string,
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PresentationStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetAgentPresentationStats(
          agentId,
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentPresentationStats']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetAgentRewardReport — распределение агентских сделок по статусу вознаграждения (expected/approved/paid/disputed/cancelled) с суммой прогноза.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetAgentRewardReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetAgentRewardReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetAgentRewardReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetAgentRewardReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetClientSourceReport — эффективность источников клиентов (client_source_type: Agent/Direct/Marketing/...): клиенты, сделки, победы, конверсия.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetClientSourceReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetClientSourceReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetClientSourceReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetClientSourceReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetClientsKpi — KPI экрана «Клиенты» (DEV-281).
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetClientsKpi(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetClientsKpiResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetClientsKpi(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetClientsKpi']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetCompanyDealsReport — сделки в разрезе компании-партнёра (+ число агентов).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetCompanyDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetCompanyDealsReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetCompanyDealsReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetCompanyDealsReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetDashboardMetrics — все метрики дашборда одним вызовом (DEV-280): KPI (клиенты/сделки/объекты/конверсия) + спарклайны + донат источников лидов + помесячный график сделок. Заменяет 3 fan-out вызова + N+1 на донате.
     * @param {string} [period] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetDashboardMetrics(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDashboardMetricsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetDashboardMetrics(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetDashboardMetrics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetDealsKpi — KPI экрана «Сделки» + разрез по этапам для канбана (DEV-282).
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetDealsKpi(
      period?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetDealsKpiResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetDealsKpi(
        period,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetDealsKpi']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetFunnel — воронка: число сделок по этапам + конверсии (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetFunnel(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetFunnelResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetFunnel(
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetFunnel']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLandingConversionReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (
        axios?: AxiosInstance,
        basePath?: string,
      ) => AxiosPromise<V1GetLandingConversionReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLandingConversionReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLandingConversionReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLeadSourcesReport — распределение по источникам лидов (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetLeadSourcesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetLeadSourcesReportResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetLeadSourcesReport(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetLeadSourcesReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetManagerAnalytics — аналитика работы менеджеров (DEV-380, наследие DEV-197): участие по этапам воронки, исходы Won/Lost при участии, задачи выполнено/просрочено. ТОЛЬКО HOS/ADMIN. Имена менеджеров FE резолвит по manager_id (useManagers).
     * @param {string} [from] начало периода (пусто &#x3D; без границы)
     * @param {string} [to] конец периода (пусто &#x3D; без границы)
     * @param {Array<string>} [managerIds] фильтр по менеджерам (пусто &#x3D; все)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetManagerAnalytics(
      from?: string,
      to?: string,
      managerIds?: Array<string>,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagerAnalyticsResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetManagerAnalytics(
        from,
        to,
        managerIds,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetManagerAnalytics']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetManagerLeaderboard — лидерборд менеджеров (DEV-285/DEV-197). ТОЛЬКО HOS/ADMIN.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetManagerLeaderboard(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetManagerLeaderboardResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetManagerLeaderboard(
          periodPeriod,
          periodFrom,
          periodTo,
          paginationPage,
          paginationPerPage,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetManagerLeaderboard']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetMyPresentationStats — статистика презентаций текущего агента (self-scope, роль AGENT): создано/отправлено/просмотры, конверсия, суточная динамика, топ.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetMyPresentationStats(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1PresentationStatsResponse>
    > {
      const localVarAxiosArgs =
        await localVarAxiosParamCreator.analyticsServiceGetMyPresentationStats(
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetMyPresentationStats']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetRevenueReport — отчёт по выручке с группировкой (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [groupBy] Группировка: временные бакеты или категории.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetRevenueReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      groupBy?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetRevenueReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetRevenueReport(
        periodPeriod,
        periodFrom,
        periodTo,
        groupBy,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetRevenueReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary GetLandingConversionReport — «лиды / просмотры» по каждому лендингу за период. Маркетинговый отчёт по общему активу: ADMIN/HOS/CEO, скоупа по менеджеру нет. GetSalesReport — отчёт отдела продаж (DEV-1067, ADR-0034): статусная структура заявок, помесячная динамика, эффективность источников, качество агентских лидов. Только HOS/ADMIN/CEO.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceGetSalesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: RawAxiosRequestConfig,
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1GetSalesReportResponse>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceGetSalesReport(
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceGetSalesReport']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary RunReconcile — разовая сверка read-model с источниками (ТОЛЬКО admin/HOS). Тянет сделки/клиентов/объекты из сервисов под токеном вызвавшего и идемпотентно наполняет fact-таблицы. Асинхронно: отвечает сразу.
     * @param {V1RunReconcileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async analyticsServiceRunReconcile(
      body: V1RunReconcileRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<V1RunReconcileResponse>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.analyticsServiceRunReconcile(
        body,
        options,
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap['AnalyticsServiceApi.analyticsServiceRunReconcile']?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath)
    },
  }
}

/**
 * AnalyticsServiceApi - factory interface
 * @export
 */
export const AnalyticsServiceApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = AnalyticsServiceApiFp(configuration)
  return {
    /**
     *
     * @summary GetAgentDealsReport — сделки в разрезе агента: клиенты/сделки/победы/депозиты, конверсия клиент→депозит, выручка, прогноз вознаграждения.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentDealsReportResponse> {
      return localVarFp
        .analyticsServiceGetAgentDealsReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentPresentationReport — сводная по агентам (Reports-таб): строки на агента + общие totals/daily по видимым. ADMIN/HOS/CEO — все; MANAGER — только курируемые.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentPresentationReportResponse> {
      return localVarFp
        .analyticsServiceGetAgentPresentationReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentPresentationStats — та же статистика по конкретному агенту (карточка агента в CRM). ADMIN/HOS/CEO — любой агент; MANAGER — только курируемый.
     * @param {string} agentId
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentPresentationStats(
      agentId: string,
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1PresentationStatsResponse> {
      return localVarFp
        .analyticsServiceGetAgentPresentationStats(
          agentId,
          periodPeriod,
          periodFrom,
          periodTo,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetAgentRewardReport — распределение агентских сделок по статусу вознаграждения (expected/approved/paid/disputed/cancelled) с суммой прогноза.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetAgentRewardReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetAgentRewardReportResponse> {
      return localVarFp
        .analyticsServiceGetAgentRewardReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetClientSourceReport — эффективность источников клиентов (client_source_type: Agent/Direct/Marketing/...): клиенты, сделки, победы, конверсия.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientSourceReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetClientSourceReportResponse> {
      return localVarFp
        .analyticsServiceGetClientSourceReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetClientsKpi — KPI экрана «Клиенты» (DEV-281).
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetClientsKpi(
      period?: string,
      options?: any,
    ): AxiosPromise<V1GetClientsKpiResponse> {
      return localVarFp
        .analyticsServiceGetClientsKpi(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetCompanyDealsReport — сделки в разрезе компании-партнёра (+ число агентов).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetCompanyDealsReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetCompanyDealsReportResponse> {
      return localVarFp
        .analyticsServiceGetCompanyDealsReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetDashboardMetrics — все метрики дашборда одним вызовом (DEV-280): KPI (клиенты/сделки/объекты/конверсия) + спарклайны + донат источников лидов + помесячный график сделок. Заменяет 3 fan-out вызова + N+1 на донате.
     * @param {string} [period] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDashboardMetrics(
      period?: string,
      options?: any,
    ): AxiosPromise<V1GetDashboardMetricsResponse> {
      return localVarFp
        .analyticsServiceGetDashboardMetrics(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetDealsKpi — KPI экрана «Сделки» + разрез по этапам для канбана (DEV-282).
     * @param {string} [period]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetDealsKpi(
      period?: string,
      options?: any,
    ): AxiosPromise<V1GetDealsKpiResponse> {
      return localVarFp
        .analyticsServiceGetDealsKpi(period, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetFunnel — воронка: число сделок по этапам + конверсии (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetFunnel(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetFunnelResponse> {
      return localVarFp
        .analyticsServiceGetFunnel(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLandingConversionReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetLandingConversionReportResponse> {
      return localVarFp
        .analyticsServiceGetLandingConversionReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLeadSourcesReport — распределение по источникам лидов (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetLeadSourcesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetLeadSourcesReportResponse> {
      return localVarFp
        .analyticsServiceGetLeadSourcesReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetManagerAnalytics — аналитика работы менеджеров (DEV-380, наследие DEV-197): участие по этапам воронки, исходы Won/Lost при участии, задачи выполнено/просрочено. ТОЛЬКО HOS/ADMIN. Имена менеджеров FE резолвит по manager_id (useManagers).
     * @param {string} [from] начало периода (пусто &#x3D; без границы)
     * @param {string} [to] конец периода (пусто &#x3D; без границы)
     * @param {Array<string>} [managerIds] фильтр по менеджерам (пусто &#x3D; все)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerAnalytics(
      from?: string,
      to?: string,
      managerIds?: Array<string>,
      options?: any,
    ): AxiosPromise<V1GetManagerAnalyticsResponse> {
      return localVarFp
        .analyticsServiceGetManagerAnalytics(from, to, managerIds, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetManagerLeaderboard — лидерборд менеджеров (DEV-285/DEV-197). ТОЛЬКО HOS/ADMIN.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
     * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetManagerLeaderboard(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      paginationPage?: string,
      paginationPerPage?: string,
      options?: any,
    ): AxiosPromise<V1GetManagerLeaderboardResponse> {
      return localVarFp
        .analyticsServiceGetManagerLeaderboard(
          periodPeriod,
          periodFrom,
          periodTo,
          paginationPage,
          paginationPerPage,
          options,
        )
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetMyPresentationStats — статистика презентаций текущего агента (self-scope, роль AGENT): создано/отправлено/просмотры, конверсия, суточная динамика, топ.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetMyPresentationStats(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1PresentationStatsResponse> {
      return localVarFp
        .analyticsServiceGetMyPresentationStats(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetRevenueReport — отчёт по выручке с группировкой (DEV-285).
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {string} [groupBy] Группировка: временные бакеты или категории.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetRevenueReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      groupBy?: string,
      options?: any,
    ): AxiosPromise<V1GetRevenueReportResponse> {
      return localVarFp
        .analyticsServiceGetRevenueReport(periodPeriod, periodFrom, periodTo, groupBy, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary GetLandingConversionReport — «лиды / просмотры» по каждому лендингу за период. Маркетинговый отчёт по общему активу: ADMIN/HOS/CEO, скоупа по менеджеру нет. GetSalesReport — отчёт отдела продаж (DEV-1067, ADR-0034): статусная структура заявок, помесячная динамика, эффективность источников, качество агентских лидов. Только HOS/ADMIN/CEO.
     * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
     * @param {string} [periodFrom]
     * @param {string} [periodTo]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceGetSalesReport(
      periodPeriod?: string,
      periodFrom?: string,
      periodTo?: string,
      options?: any,
    ): AxiosPromise<V1GetSalesReportResponse> {
      return localVarFp
        .analyticsServiceGetSalesReport(periodPeriod, periodFrom, periodTo, options)
        .then((request) => request(axios, basePath))
    },
    /**
     *
     * @summary RunReconcile — разовая сверка read-model с источниками (ТОЛЬКО admin/HOS). Тянет сделки/клиентов/объекты из сервисов под токеном вызвавшего и идемпотентно наполняет fact-таблицы. Асинхронно: отвечает сразу.
     * @param {V1RunReconcileRequest} body
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    analyticsServiceRunReconcile(
      body: V1RunReconcileRequest,
      options?: any,
    ): AxiosPromise<V1RunReconcileResponse> {
      return localVarFp
        .analyticsServiceRunReconcile(body, options)
        .then((request) => request(axios, basePath))
    },
  }
}

/**
 * AnalyticsServiceApi - object-oriented interface
 * @export
 * @class AnalyticsServiceApi
 * @extends {BaseAPI}
 */
export class AnalyticsServiceApi extends BaseAPI {
  /**
   *
   * @summary GetAgentDealsReport — сделки в разрезе агента: клиенты/сделки/победы/депозиты, конверсия клиент→депозит, выручка, прогноз вознаграждения.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentDealsReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentDealsReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentPresentationReport — сводная по агентам (Reports-таб): строки на агента + общие totals/daily по видимым. ADMIN/HOS/CEO — все; MANAGER — только курируемые.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentPresentationReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentPresentationReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentPresentationStats — та же статистика по конкретному агенту (карточка агента в CRM). ADMIN/HOS/CEO — любой агент; MANAGER — только курируемый.
   * @param {string} agentId
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentPresentationStats(
    agentId: string,
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentPresentationStats(
        agentId,
        periodPeriod,
        periodFrom,
        periodTo,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetAgentRewardReport — распределение агентских сделок по статусу вознаграждения (expected/approved/paid/disputed/cancelled) с суммой прогноза.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetAgentRewardReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetAgentRewardReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetClientSourceReport — эффективность источников клиентов (client_source_type: Agent/Direct/Marketing/...): клиенты, сделки, победы, конверсия.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetClientSourceReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetClientSourceReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetClientsKpi — KPI экрана «Клиенты» (DEV-281).
   * @param {string} [period]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetClientsKpi(period?: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetClientsKpi(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetCompanyDealsReport — сделки в разрезе компании-партнёра (+ число агентов).
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetCompanyDealsReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetCompanyDealsReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetDashboardMetrics — все метрики дашборда одним вызовом (DEV-280): KPI (клиенты/сделки/объекты/конверсия) + спарклайны + донат источников лидов + помесячный график сделок. Заменяет 3 fan-out вызова + N+1 на донате.
   * @param {string} [period] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetDashboardMetrics(period?: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetDashboardMetrics(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetDealsKpi — KPI экрана «Сделки» + разрез по этапам для канбана (DEV-282).
   * @param {string} [period]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetDealsKpi(period?: string, options?: RawAxiosRequestConfig) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetDealsKpi(period, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetFunnel — воронка: число сделок по этапам + конверсии (DEV-285).
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetFunnel(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetFunnel(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLandingConversionReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLandingConversionReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLeadSourcesReport — распределение по источникам лидов (DEV-285).
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetLeadSourcesReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetLeadSourcesReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetManagerAnalytics — аналитика работы менеджеров (DEV-380, наследие DEV-197): участие по этапам воронки, исходы Won/Lost при участии, задачи выполнено/просрочено. ТОЛЬКО HOS/ADMIN. Имена менеджеров FE резолвит по manager_id (useManagers).
   * @param {string} [from] начало периода (пусто &#x3D; без границы)
   * @param {string} [to] конец периода (пусто &#x3D; без границы)
   * @param {Array<string>} [managerIds] фильтр по менеджерам (пусто &#x3D; все)
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetManagerAnalytics(
    from?: string,
    to?: string,
    managerIds?: Array<string>,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetManagerAnalytics(from, to, managerIds, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetManagerLeaderboard — лидерборд менеджеров (DEV-285/DEV-197). ТОЛЬКО HOS/ADMIN.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [paginationPage] Номер страницы, 1-based; 0 трактуется как 1.
   * @param {string} [paginationPerPage] Размер страницы; 0 &#x3D; дефолт сервиса.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetManagerLeaderboard(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    paginationPage?: string,
    paginationPerPage?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetManagerLeaderboard(
        periodPeriod,
        periodFrom,
        periodTo,
        paginationPage,
        paginationPerPage,
        options,
      )
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetMyPresentationStats — статистика презентаций текущего агента (self-scope, роль AGENT): создано/отправлено/просмотры, конверсия, суточная динамика, топ.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetMyPresentationStats(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetMyPresentationStats(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetRevenueReport — отчёт по выручке с группировкой (DEV-285).
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {string} [groupBy] Группировка: временные бакеты или категории.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetRevenueReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    groupBy?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetRevenueReport(periodPeriod, periodFrom, periodTo, groupBy, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary GetLandingConversionReport — «лиды / просмотры» по каждому лендингу за период. Маркетинговый отчёт по общему активу: ADMIN/HOS/CEO, скоупа по менеджеру нет. GetSalesReport — отчёт отдела продаж (DEV-1067, ADR-0034): статусная структура заявок, помесячная динамика, эффективность источников, качество агентских лидов. Только HOS/ADMIN/CEO.
   * @param {string} [periodPeriod] \&quot;day\&quot;|\&quot;week\&quot;|\&quot;month\&quot;; пусто &#x3D; \&quot;month\&quot;
   * @param {string} [periodFrom]
   * @param {string} [periodTo]
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceGetSalesReport(
    periodPeriod?: string,
    periodFrom?: string,
    periodTo?: string,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceGetSalesReport(periodPeriod, periodFrom, periodTo, options)
      .then((request) => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary RunReconcile — разовая сверка read-model с источниками (ТОЛЬКО admin/HOS). Тянет сделки/клиентов/объекты из сервисов под токеном вызвавшего и идемпотентно наполняет fact-таблицы. Асинхронно: отвечает сразу.
   * @param {V1RunReconcileRequest} body
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof AnalyticsServiceApi
   */
  public analyticsServiceRunReconcile(
    body: V1RunReconcileRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return AnalyticsServiceApiFp(this.configuration)
      .analyticsServiceRunReconcile(body, options)
      .then((request) => request(this.axios, this.basePath))
  }
}
